"use client";

import { CustomIcon } from "@/components/custom/icons/custom-icon";
import { Popover, PopoverContent } from "@/components/ui/popover";
import { PopoverTrigger } from "@radix-ui/react-popover";
import { Typography } from "@/components/custom/typography";
import { useNotificationDataInfinite } from "@/hooks/notification-hooks/useNotificationData";
import { NotificationList } from "./NotificationList";
// no react hooks directly needed here other than those used by imported hooks/components

export default function NotificationBell() {
  // rely on computed counts from query
  const { unreadCounts } = useNotificationDataInfinite("all");
  // Use Announcement count for the bell badge
  const bellCount = unreadCounts?.all ?? 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="relative h-9 flex items-center text-gray-900 mr-7 cursor-pointer">
          <CustomIcon name="Bell" size={9} className="text-gray-900" />
          {bellCount > 0 && (
            <Typography
              as={"span"}
              className={
                "absolute -top-1 -right-3 inline-flex items-center justify-center w-[24px] h-[20px] bg-red-500 text-white text-xs font-semibold rounded-full leading-none"
              }
            >
              {bellCount > 99 ? "99+" : bellCount}
            </Typography>
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent
        sideOffset={20}
        align="end"
        className="w-screen max-w-2xl rounded-2xl shadow-xl/30 border-0 p-4"
      >
        <NotificationList />
      </PopoverContent>
    </Popover>
  );
}
